import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';

import LoadingScreen from '../../../components/LoadingScreen';

const ChildWalletsListComponent = React.lazy(() => import('./components/ChildWalletsList'));

const ChildWalletsList = () => {
  const { pathname } = useLocation();
  return (
    <div>
      <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
        <ChildWalletsListComponent />
      </Suspense>
    </div>
  );
}

export default ChildWalletsList;